let d = window.define;
d("ember-tracked-storage-polyfill/index", function () {
  return esc(require("ember-tracked-storage-polyfill/index"));
});
import "ember-tracked-storage-polyfill/-embroider-implicit-modules.js";
import esc from "../../@embroider/macros/src/addon/es-compat2";